class RecursiveConstraintError extends Error {
	constructor(...params) {
		// Pass remaining arguments (including vendor specific ones) to parent constructor
		// noinspection JSCheckFunctionSignatures
		super(...params);

		// Maintains proper stack trace for where our error was thrown (only available on V8)
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, RecursiveConstraintError);
		}

		this.name = "RecursiveConstraintError";
	}
}

export {RecursiveConstraintError}
